import React from 'react'
import { hooks } from '@front/volcanion'

import { TableCell, Box, Tooltip } from '@mui/material'
import { TextCell } from '@abra/elements/table/cells/basics/'

const Status = ({ row }) => {
  const load_type = row?.loads?.[0]?.type
  const orderStatus = hooks.useOrderStatus(row, { translated: true })
  const transportStatus = hooks.useTransportStatus(row?.assigned_transport, { translated: true, load_type })
  const orderStatusColor = hooks.useOrderStatusColor(row)
  return (
    <TableCell padding='none'>
      <Tooltip title={orderStatus}>
        <Box display='flex' alignItems='center' justifyContent='center'>
          <TextCell fontSize={13} value={orderStatus} color={orderStatusColor} />
        </Box>
      </Tooltip>
      <TextCell fontSize={13} value={transportStatus} color={hooks.useTransportStatusColor(row?.assigned_transport)} />
    </TableCell>
  )
}

export default React.memo(Status)
